import Modal from "react-bootstrap/Modal";
import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import DateInput from "../sharedComponents/datesInputs/date";
import DropDownList from "../sharedComponents/dropdown/dropdown";
import Icon from "../sharedComponents/icons/fontawsomeIcons";
import Lang from "../../userPreferences/staticWords";
import TextArea from "../sharedComponents/textarea/textArea";
import TextInput from "../sharedComponents/inputs/textInput";
import { useEffect, useState } from "react";
import FileUploader from "../reusableComponents/fileUploader";
import { useFormik } from "formik";
import {
  formikSetup,
  formikValidation,
  initialValues,
  validationSchema,
} from "./formikValidation";
import Alerts from "../reusableComponents/alert";
import FilesList from "../reusableComponents/filesList";
import Button from "../sharedComponents/buttons/button";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentLangFromRedux, getDir } from "../../algorithms/styleChanges";
import MembersList, { removeItem } from "../../algorithms/listsAlogrithms";
import { resolver } from "../../API/middlewares/resolveRequests";
import {
  addActivityForm,
  getProjectActivityForm,
} from "../../API/store/actions/projects/projects";
import * as actionTypes from "../../API/store/actions/actionTypes";
import { englishDate } from "../../algorithms";

const CreateNewActivity = (props) => {
  const {
    onHide,
    TaskStatusDropdownList,
    setTaskStatusDropdownList,
    PriorityDropdownList,
    setPriorityDropdownList,
    setProcAdded,
    procAdded,
    projectId,
    milestones,
  } = props;
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);

  const [AdminActivityMembersLists, setAdminActivityMembersLists] = useState(
    []
  );
  const [ActivityMembersLists, setActivityMembersLists] = useState([]);
  const [Milestones, setMilestones] = useState([]);
  const [dropdowns, setDrobdowns] = useState({});

  const userToken = useSelector((state) => state.login.userToken);

  useEffect(() => {
    resolver(getProjectActivityForm, setDrobdowns, projectId, userToken);
  }, []);

  useEffect(() => {
    if (dropdowns?.data?.members) {
      setAdminActivityMembersLists(dropdowns?.data?.members);
      setActivityMembersLists(dropdowns?.data?.members);
    }
    if (dropdowns?.data?.priorityLkp)
      setPriorityDropdownList(dropdowns?.data?.priorityLkp);
    if (dropdowns?.data?.projectStatusLkp)
      setTaskStatusDropdownList(dropdowns?.data?.projectStatusLkp);

    setMilestones(milestones);
  }, [dropdowns]);

  const [files, setFiles] = useState([]);

  const [adminListError, setAdminListError] = useState(false);

  const [duplicateAlert, setDuplicateAlert] = useState(false);
  const dispatch = useDispatch();
  const [disable, setDisable] = useState(false);

  const saveHandler = async (values) => {
    let formData = new FormData();
    const newData = {
      NameA: values.Name,
      NameE: values.Name,
      DescriptionA: values.Description,
      DescriptionE: values.Description,
      StartDate: englishDate(values.StartDate) + "T00:00:00",
      EndDate: englishDate(values.EndDate) + "T00:00:00",
      EstimatedTime: parseInt(values.EstimatedTime),
      PriorityId: parseInt(values.PriorityId),
      files: values.files,
      ActivityStatusId: parseInt(values.ActivityStatusId),
      ProjectId: parseInt(projectId),
      ExecutionPercentage: parseInt(values.ExecutionPercentage),
      MilestoneId: parseInt(values.MilestoneId),
      AdminActivityMembers: values.AdminActivityMembers,
      ActivityMembers: values.ActivityMembers,
    };

    for (let [key, value] of Object.entries(newData)) {
      if (key == "files") {
        value.forEach((element) => {
          formData.append("files", element.file);
        });
      } else if (key == "AdminActivityMembers") {
        value.forEach((element) => {
          formData.append("AdminActivityMembers", element);
        });
      } else if (key == "ActivityMembers") {
        value.forEach((element) => {
          formData.append("ActivityMembers", element);
        });
      } else {
        formData.append(key, value);
      }
    }

    if (startDateError === false && endDateError === false) {
      if (values.AdminActivityMembers.length > 0) {
        setAdminListError(false);
        if (disable) {
          return;
        } else {
          setDisable(true);
        }
        let res = await addActivityForm(formData, userToken);
        if (res.status <= 206) {
          setPriorityDropdownList(dropdowns?.data?.priorityLkp);
          setTaskStatusDropdownList(dropdowns?.data?.projectStatusLkp);
          setMilestones(milestones);
          setFiles([]);
          resetForm();
          setStartDate("");
          setEndDate("");
          dispatch({ type: actionTypes.RELOAD });
          onHide();
          setProcAdded(!procAdded);
          setDisable(false);
        } else {
          setDisable(false);
        }
      } else {
        setDisable(false);
        setAdminListError(true);
      }
    }
  };

  const formik = useFormik(
    formikSetup(
      initialValues,
      undefined,
      validationSchema,
      "createNewActivity",
      saveHandler
    )
  );

  const {
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    values,
    setFieldTouched,
    handleChange,
    resetForm,
  } = formik;

  return (
    <Modal
      // show={show}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      {...props}
      style={{ zIndex: 1000000 }}
      backdrop="static"
    >
      <Modal.Header style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <Modal.Title id="contained-modal-title-vcenter">
          <div className="d-flex align-items-center">
            <div
              className="mx-2 d-flex justify-content-center align-items-center"
              style={{
                height: 32,
                width: 32,
              }}
            >
              <img src="/assets/images/Group 8262.png" width={40} height={30} />
            </div>
            <div className="text-dark">
              <p
                className="my-0 mx-1"
                style={{
                  fontSize: 18,
                  textAlign: "justify",
                  color: "#1a73e8",
                }}
              >
                {Lang.createNewActivity}
              </p>
            </div>
          </div>
        </Modal.Title>
        <div className={`d-flex justify-content-end mt-2 ${styleEnd("m", 3)}`}>
          <Icon
            name="times"
            size={22}
            color={"#1A73E8"}
            onclick={() => {
              onHide();
              setPriorityDropdownList(dropdowns?.data?.priorityLkp);
              setTaskStatusDropdownList(dropdowns?.data?.projectStatusLkp);
              setFiles([]);
              setStartDate("");
              setEndDate("");
              resetForm();
              setAdminListError(false);
              setDisable(false);
            }}
          />
        </div>
      </Modal.Header>

      <Modal.Body style={{ direction: getDir(getCurrentLangFromRedux()) }}>
        <form onSubmit={handleSubmit}>
          <TextArea
            name={"Name"}
            containerStyle={"mb-4 col-12 align-items-center"}
            placeholder={Lang.title + "*"}
            rows="3"
            contentStyle={`scroll col-11 p-1`}
            onChange={handleChange}
            errorMessage={formikValidation(touched, errors, "Name")}
          />

          <TextArea
            name={"Description"}
            containerStyle={"mb-4 col-12 align-items-center"}
            placeholder={Lang.Description}
            rows="3"
            contentStyle={`scroll col-11 p-1`}
            onChange={handleChange}
            errorMessage={formikValidation(touched, errors, "Description")}
          />

          <div className="d-flex flex-xl-row justify-content-center align-items-center align-items-xl-start col-12 flex-column mt-4">
            <div
              className={`d-flex flex-column align-items-center col-12 my-2 col-xl-6`}
            >
              <p className="mb-3 px-xl-5 px-3 col-12">
                {Lang.periodTime + "*"}
              </p>
              <div className="d-flex col-12 flex-xl-row flex-column align-items-center align-items-xl-start">
                <div className={`col-12 col-xl-6 me-xl-4 px-3 px-xl-0 pe-xl-4`}>
                  <DateInput
                    errorMessage={
                      formikValidation(touched, errors, "StartDate") ||
                      startDateError === true
                        ? Lang.invalidDate
                        : null
                    }
                    placeholder={Lang.from}
                    containerStyle={`col-12 col-xl-11 ${styleStart(
                      "m",
                      5,
                      "xl"
                    )}`}
                    name={"StartDate"}
                    value={values.StartDate}
                    onChange={(e) => {
                      setFieldValue("StartDate", e);
                      if (values.EndDate)
                        if (new Date(values.EndDate) >= new Date(e)) {
                          setEndDateError(false);
                          setStartDateError(false);
                        } else setStartDateError(true);
                    }}
                    iconPrefix="far"
                    iconName="calendar"
                    iconSize={22}
                  />
                </div>

                <div
                  className={`col-12 col-xl-6 px-3 px-xl-0  pe-xl-3 ps-xl-4`}
                >
                  <DateInput
                    errorMessage={
                      formikValidation(touched, errors, "EndDate") ||
                      endDateError === true
                        ? Lang.invalidDate
                        : null
                    }
                    placeholder={Lang.to}
                    containerStyle={`col-12 col-xl-11 ${styleStart(
                      "m",
                      3,
                      "xl"
                    )}`}
                    value={values.EndDate}
                    onChange={(e) => {
                      setFieldValue("EndDate", e);
                      if (values.StartDate)
                        if (new Date(values.StartDate) <= new Date(e)) {
                          setEndDateError(false);
                          setStartDateError(false);
                        } else setEndDateError(true);
                    }}
                    iconPrefix="far"
                    iconName="calendar"
                    iconSize={22}
                  />
                  {/* {endDateError === true ? (
                    <div>
                      <p className="my-2 text-danger">{Lang.invalidDate}</p>
                    </div>
                  ) : null} */}
                </div>
              </div>
            </div>

            <div className={`d-flex flex-column my-2 col-xl-3 col-12`}>
              <p className="mb-3 px-3 px-xl-2 col-12">{Lang.predictedTime}</p>
              <div
                className={`d-flex flex-xl-row flex-column align-items-xl-center  col-12 ms-xl-0 ${styleEnd(
                  "p",
                  4,
                  "xl"
                )} ${styleStart("p", 0, "xl")} px-4`}
              >
                <div className={`d-flex align-items-xl-center col-12 mb-2`}>
                  <TextInput
                    name={"EstimatedTime"}
                    value={values.EstimatedTime}
                    onChange={handleChange}
                    errorMessage={formikValidation(
                      touched,
                      errors,
                      "EstimatedTime"
                    )}
                    hiddenPlaceholder={Lang["(ex:5Days)"]}
                    containerStyle={`col-12 ${styleStart("m", 2, "xl")}`}
                    type={"number"}
                    disable={false}
                    min={0}
                  />
                </div>
              </div>
            </div>

            <div className={`d-flex flex-column col-xl-3 col-12 my-2`}>
              <p className="mb-3 px-3 px-xl-1 col-12">
                {Lang.executionPercentage}
              </p>
              <div
                className={`d-flex flex-xl-row flex-column align-items-xl-center col-xl-10 col-12 ms-xl-0 px-4 px-xl-0`}
              >
                <div className={`d-flex align-items-xl-center col-12 mb-2`}>
                  <TextInput
                    name={"ExecutionPercentage"}
                    value={values.ExecutionPercentage}
                    onChange={handleChange}
                    errorMessage={formikValidation(
                      touched,
                      errors,
                      "ExecutionPercentage"
                    )}
                    hiddenPlaceholder={Lang.executionPercentage}
                    containerStyle={"col-12"}
                    type={"number"}
                    disable={false}
                    min={0}
                    max={100}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex flex-xl-row justify-content-center align-items-center col-12 flex-column mb-4 mt-2">
            <DropDownList
              placeholder={Lang.priority + "*"}
              border={true}
              containerStyle={`col-12 mb-3 px-4 col-xl-4 ${styleEnd(
                "p",
                2,
                "xl"
              )} ${styleStart("p", 5, "xl")}`}
              dataSource={PriorityDropdownList}
              value={values.PriorityId}
              change={(e) => {
                setFieldValue("PriorityId", e.value);
              }}
              errorMessage={formikValidation(touched, errors, "PriorityId")}
            />

            <DropDownList
              placeholder={Lang.activityStatus + "*"}
              border={true}
              containerStyle={`col-12 mb-3 px-4 px-xl-2 col-xl-4`}
              dataSource={TaskStatusDropdownList}
              value={values.ActivityStatusId}
              change={(e) => {
                setFieldValue("ActivityStatusId", e.value);
              }}
              errorMessage={formikValidation(
                touched,
                errors,
                "ActivityStatusId"
              )}
            />

            <DropDownList
              placeholder={Lang.milestones + "*"}
              border={true}
              containerStyle={`col-12 mb-3 px-4 col-xl-4 ${styleEnd(
                "p",
                5,
                "xl"
              )} ${styleStart("p", 2, "xl")}`}
              dataSource={Milestones}
              value={values.MilestoneId}
              change={(e) => {
                setFieldValue("MilestoneId", e.value);
              }}
              errorMessage={formikValidation(touched, errors, "MilestoneId")}
            />
          </div>

          <MembersList
            onChangeSearch={(e) => {
              let searchKey = e.target.value; //HERE FILTER
              setAdminActivityMembersLists(
                [
                  ...dropdowns?.data?.members.filter(
                    (member) =>
                      ![...values.ActivityMembers].some(
                        (admin) => admin.memberId == member.memberId
                      )
                  ),
                ].filter((item) => item.memberName.includes(searchKey))
              );
            }}
            containerStyle="d-flex flex-column mx-xl-4 mx-3 mb-4 col-12"
            aboveTitleStyle={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}
            aboveTitle={Lang.addAdmainMembers + "*"}
            cardStyle={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
              "TitleCard"
            )}`}
            cardTitle={Lang.adminMembers}
            list={AdminActivityMembersLists}
            id={"A"}
            checked={true}
            values={values.AdminActivityMembers}
            onChange={(e) => {
              if (e.target.checked) {
                setFieldValue("AdminActivityMembers", [
                  ...values.AdminActivityMembers,
                  parseInt(e.target.value),
                ]);
                setActivityMembersLists(
                  ActivityMembersLists.filter(
                    (item) =>
                      parseInt(item.memberId) !== parseInt(e.target.value)
                  )
                );
                setAdminListError(false);
              } else {
                setActivityMembersLists([
                  AdminActivityMembersLists.find(
                    (item) =>
                      parseInt(e.target.value) === parseInt(item.memberId)
                  ),
                  ...ActivityMembersLists,
                ]);
                setFieldValue(
                  "AdminActivityMembers",
                  removeItem(
                    values.AdminActivityMembers,
                    parseInt(e.target.value)
                  )
                );
                if (values.AdminActivityMembers.length > 0) {
                  setAdminListError(false);
                } else {
                  setAdminListError(true);
                }
              }
            }}
            listError={adminListError}
          />

          <MembersList
            onChangeSearch={(e) => {
              let searchKey = e.target.value; //HERE FILTER
              setActivityMembersLists(
                [
                  ...dropdowns?.data?.members.filter(
                    (member) =>
                      ![...values.AdminActivityMembers].some(
                        (admin) => admin.memberId == member.memberId
                      )
                  ),
                ].filter((item) => item.memberName.includes(searchKey))
              );
            }}
            containerStyle="d-flex flex-column mx-xl-4 mx-3 mb-5 col-12"
            aboveTitleStyle={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}
            aboveTitle={Lang.addMembers}
            cardStyle={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
              "TitleCard"
            )}`}
            id={"B"}
            checked={true}
            values={values.ActivityMembers}
            cardTitle={Lang.Members}
            list={ActivityMembersLists}
            onChange={(e) => {
              if (e.target.checked) {
                setFieldValue("ActivityMembers", [
                  ...values.ActivityMembers,
                  parseInt(e.target.value),
                ]);
                setAdminActivityMembersLists([
                  ...AdminActivityMembersLists.filter(
                    (item) =>
                      parseInt(item.memberId) !== parseInt(e.target.value)
                  ),
                ]);
              } else {
                setAdminActivityMembersLists([
                  ActivityMembersLists.find(
                    (item) =>
                      parseInt(e.target.value) === parseInt(item.memberId)
                  ),
                  ...AdminActivityMembersLists,
                ]);
                setFieldValue(
                  "ActivityMembers",
                  removeItem(values.ActivityMembers, parseInt(e.target.value))
                );
              }
            }}
            listError={false}
          />

          <div className="col-12 px-4 px-xl-5">
            <Alerts
              variant={"danger"}
              buttonContent={
                getDir(getCurrentLangFromRedux()) == "rtl" ? "إغلاق" : "close"
              }
              content={
                getDir(getCurrentLangFromRedux()) == "rtl"
                  ? "هذا الملف تم رفعه من قبل"
                  : "this file uploaded already"
              }
              title={
                getDir(getCurrentLangFromRedux()) == "rtl"
                  ? "ملف متكرر"
                  : "duplicate file"
              }
              show={duplicateAlert}
              setShow={setDuplicateAlert}
            />
          </div>

          <div className="d-flex flex-column mx-4 px-xl-4 mb-3">
            <FileUploader
              containerStyle={"col-12"}
              contentStyle={"col-12"}
              borderColor={"#C7C7C9"}
              placeholderLTRWidth={150}
              placeholderRTLWidth={115}
              fileIconColor={"#1a73e8"}
              fileValue={values.file}
              fileOnClick={(e) => {
                e.target.value = "";
                setFieldValue("file", e.target.value);
              }}
              FileOnChange={(e) => {
                setFieldValue("file", e.target.files[0]);
              }}
              uploadButtonOnChange={() => {
                if (values.file) {
                  if (
                    !files.find(
                      (item) => item.fileName === values.file.name.substr(0, 35)
                    )
                  ) {
                    const allFiles = [
                      ...files,
                      {
                        id: files.length + 1,
                        fileName: values.file.name.substr(0, 35),
                        file: values.file,
                      },
                    ];
                    setFieldValue("files", [...allFiles]);
                    setFiles([...allFiles]);
                    setFieldValue("file", "");
                    setFieldTouched("files", false);
                  } else {
                    setDuplicateAlert(true);
                    setTimeout(() => {
                      setDuplicateAlert(false);
                    }, 1000);
                  }
                }
              }}
            />
            <FilesList
              containerStyle={"col-12 justify-content-start"}
              contentStyle={"col-12"}
              Data={[...files]}
              setFiles={setFiles}
              setFilesInFormik={setFieldValue}
              setFilesTouched={setFieldTouched}
              propInFormik={"files"}
            />
          </div>

          <div className="d-flex flex-sm-row justify-content-center mt-5 mb-3 col-12">
            <Button
              disable={disable}
              content={disable ? Lang.saving : Lang.save}
              containerStyle="col-3 mx-3"
              onClick={() => {
                if (values.AdminActivityMembers.length > 0)
                  setAdminListError(false);
                else setAdminListError(true);
              }}
              type={"submit"}
              buttonStyleType={"solid"}
            />

            <Button
              content={Lang.cancel}
              containerStyle="col-3 mx-3"
              onClick={() => {
                onHide();
                setPriorityDropdownList(dropdowns?.data?.priorityLkp);
                setTaskStatusDropdownList(dropdowns?.data?.projectStatusLkp);
                setFiles([]);
                resetForm();
                setStartDate("");
                setEndDate("");
                setAdminListError(false);
                setDisable(false);
              }}
            />
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};
export default CreateNewActivity;
